import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button } from 'streamlabs-beaker';

@Component({
  components: {
    SButton: Button,
  },
})
export default class BasicModalMixin extends Vue {
  @Prop()
  name!: string;

  @Prop({ default: 600 })
  width!: number | string;

  @Prop({ default: 0 })
  minWidth!: number;

  @Prop({ default: 0 })
  minHeight!: number;

  @Prop({ default: 'auto' })
  height!: number | string;

  @Prop()
  title!: string;

  @Prop()
  subTitle!: string;

  @Prop()
  text!: string;

  @Prop()
  hideActionButtons!: string;

  @Prop({ default: 'Confirm' })
  confirmButtonText!: string;

  @Prop({ default: 'Close' })
  closeButtonText!: string;

  @Prop({ default: 'action' })
  confirmButtonVariation!: string;

  @Prop({ default: null })
  closeButtonVariation!: string;

  @Prop({ default: true })
  clickToClose!: boolean;

  @Prop({ default: false })
  confirmDisabled!: boolean;

  @Prop({ default: false })
  fullScreen!: boolean;

  @Prop({ default: false })
  confirmButtonOnly!: boolean;

  @Prop({ default: false })
  confirmationButtonDisabled!: boolean;

  get modalClasses(): string[] {
    const classes = ['modal-wrapper'];

    if (this.fullScreen) classes.push('modal-wrapper--full-screen');

    return classes;
  }

  get hasFooterSlot(): boolean {
    return !!this.$slots.footer;
  }

  onDismiss() {
    this.$modal.hide(this.name);
    this.$emit('dismiss');
  }

  onResize() {
    (this.$refs[this.name] as any).setInitialSize();
  }
}
